import React from 'react';

import { GoogleMap, InfoWindow, LoadScriptNext, Marker } from '@react-google-maps/api';
import { Waypoint } from 'react-waypoint';

import { Artist as ArtistCell, ShowVertical } from '../common/container/Cell.jsx';
import { NoResults, Spaced, Tab, Title, TitleSpaced, forResource } from '../common/container/Container.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { Popup } from '../common/container/Popup.jsx';
import HubspotForm from '../common/container/HubspotForm.jsx';
import { Galleries as GalleriesSlider, Shows as ShowsSlider } from '../common/container/Slider.jsx';
import { Follow as FollowButton, LinkButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { LinkedImage } from '../common/container/Image.jsx';

let _CityInst;
class _City extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artists: {
                loading: false,
                q: {
                    limit: 20,
                    offset: 0
                }
            },
            galleries: {
                loading: true,
                mapVisible: true
            },
            showsCurrent: {
                loading: true
            },
            showsPast: {
                loading: false,
                q: {
                    limit: 18,
                    offset: 0,
                    when: 2
                }
            }
        };

        this.showsSliderConfig = {
            items: 2,
            loop: true,
            margin: 16.67,
            nav: true,
            navText: ["", ""],
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 768 up
                768: {
                    items: 2,
                    slideBy: 2
                }
            },
            rewindNav: true
        };

        this.configureTabs = this.configureTabs.bind(this);
        this.getArtists = this.getArtists.bind(this);
        this.getGalleries = this.getGalleries.bind(this);
        this.getShowsCurrent = this.getShowsCurrent.bind(this);
        this.getShowsPast = this.getShowsPast.bind(this);
        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtistsWaypointEnter = this.handleArtistsWaypointEnter.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleGalleryAddClick = this.handleGalleryAddClick.bind(this);
        this.handleGalleryAddClose = this.handleGalleryAddClose.bind(this);
        this.handleMetaClick = this.handleMetaClick.bind(this);
        this.handleShowsWaypointEnter = this.handleShowsWaypointEnter.bind(this);
        this.handleToggleGalleryMapVisibilty = this.handleToggleGalleryMapVisibilty.bind(this);
    }

    componentDidMount() {
        _CityInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.cities._isfollowing(responseData);

            const id = component.props.slug;
            component.getArtists(id);
            component.getGalleries(id);
            component.getShowsCurrent(id);
            component.getShowsPast(id);
            component.configureTabs();
        });
    }

    componentWillUnmount() {
        _CityInst = undefined;

        if (this.artistsRequest) {
            this.artistsRequest.abort();
            this.artistsRequest = null;
        }
        if (this.galleriesRequest) {
            this.galleriesRequest.abort();
            this.galleriesRequest = null;
        }
        if (this.showsCurrentRequest) {
            this.showsCurrentRequest.abort();
            this.showsCurrentRequest = null;
        }
        if (this.showsPastRequest) {
            this.showsPastRequest.abort();
            this.showsPastRequest = null;
        }
    }

    configureTabs() {
        const tabs = [
            { active: true, label: 'Overview', tab: 'overview' },
            { label: 'Shows', tab: 'shows' },
            { label: 'Galleries', tab: 'galleries' },
            { label: 'Artists', tab: 'artists' },
            { label: 'Museums', tab: 'museums' }
        ];
        this.props.onConfigureTabs(tabs, 'overview');
    }

    getArtists(id) {
        const component = this;
        const state = component.state.artists;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artists: state
        });
        component.artistsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.artists.get(id),
            state.q,
            function (responseData) {
                component.artistsRequest = null;

                responseData.Artists.forEach(function (d) {
                    if (d.Image) {
                        d.ImgSrc = d.Image.Url;
                    }
                    Artcloud.mkt.artists._isfollowing(d);
                });
                let data = state.data || [];
                state.data = data.concat(responseData.Artists);

                state.q.offset += responseData.Artists.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artists: state
                });
            },
            function (jqXHR, textStatus) {
                component.artistsRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    artists: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getGalleries(id) {
        const component = this;
        component.galleriesRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.galleries.get(id),
            null,
            function (responseData) {
                component.galleriesRequest = null;

                const data = [];
                const featured = [];
                responseData.Data.forEach(function (d) {
                    Artcloud.mkt.galleries._isfollowing(d);

                    if (d.Image && d.IsFeatured) {
                        featured.push(d);
                    }
                    if (d.Company) {
                        d.mapLabel = {
                            color: '#fff',
                            text: d.Company.split(' ').map(function (v) {
                                const name = v.toUpperCase();
                                const articles = ['THE', 'OF', 'AT', 'IN', 'A', 'AN'];
                                if (!articles.includes(name)) {
                                    return name[0];
                                }
                            }).slice(0, 2).join(''),
                        };
                    }
                    data.push(d);
                })
                component.setState({
                    galleries: {
                        all: data,
                        featured: featured,
                        mapVisible: component.state.galleries.mapVisible
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.galleriesRequest = null;

                component.setState({
                    galleries: {
                        all: [],
                        featured: [],
                        mapVisible: component.state.galleries.mapVisible
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsCurrent(id) {
        const component = this;
        component.showsCurrentRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.shows.get(id),
            { when: 1 },
            function (responseData) {
                component.showsCurrentRequest = null;
                component.setState({
                    showsCurrent: {
                        data: responseData.Shows,
                        total: responseData.Total
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.showsCurrentRequest = null;

                component.setState({
                    showsCurrent: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsPast(id) {
        const component = this;
        const state = component.state.showsPast;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            showsPast: state
        });
        component.showsPastRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.shows.get(id),
            state.q,
            function (responseData) {
                component.showsPastRequest = null;

                let data = state.data || [];
                state.data = data.concat(responseData.Shows);

                state.q.offset += responseData.Shows.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    showsPast: state
                });
            },
            function (jqXHR, textStatus) {
                component.showsPastRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    showsPast: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtistFollowChange(d) {
        const state = this.state.artists;
        let artist;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_CityInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.setState({
                artists: state
            });
        });
    }

    handleArtistsWaypointEnter() {
        if (!this.state.artists.data || (this.state.artists.data && this.state.artists.q.offset >= this.state.artists.total)) {
            return;
        }
        this.getArtists(this.props.slug);
    }

    handleFollowChange() {
        const component = this;
        const city = this.props.data;
        Artcloud.mkt.cities.updateFollowing(city.CityId, !city.IsFollowing, component.props.slug, function (success) {
            if (success != true || !_CityInst) {
                return;
            }
            city.IsFollowing = !city.IsFollowing;
            component.props.onUpdateData(city);
        });
    }

    handleGalleryAddClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            galleryAddModal: true
        });
    }

    handleGalleryAddClose() {
        this.setState({
            galleryAddModal: undefined
        });
    }

    handleMetaClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (!event.currentTarget.attributes.name || !event.currentTarget.attributes.name.value) {
            return;
        }
        this.props.onTabClick(event.currentTarget.attributes.name.value);
    }

    handleShowsWaypointEnter() {
        if (!this.state.showsPast.data || (this.state.showsPast.data && this.state.showsPast.q.offset >= this.state.showsPast.total)) {
            return;
        }
        this.getShowsPast(this.props.slug);
    }

    handleToggleGalleryMapVisibilty(event) {
        if (event) {
            event.preventDefault();
        }
        const galleries = this.state.galleries;
        galleries.mapVisible = !galleries.mapVisible;
        this.setState({
            galleries: galleries
        });
    }

    render() {
        const data = this.props.data || {};
        const imageStyle = { backgroundSize: 'auto 100%', backgroundColor: '#ffffff' };
        if (data.Image) {
            imageStyle.backgroundImage = `url('${data.Image.Url}')`;
        }
        let className = '';
        let tabExtras;
        if (this.props.tab == 'galleries') {
            tabExtras = (
                <div className="toggle__cont">
                    <a href="#" onClick={this.handleToggleGalleryMapVisibilty}>{this.state.galleries.mapVisible ? 'Show List' : 'Show Map'}</a>
                </div>
            );
            if (this.state.galleries.mapVisible) {
                className += ' tabs__content--no__padding';
            }
        }
        const hasCurrentShows = this.state.showsCurrent.data && this.state.showsCurrent.data.length > 0;

        return (
            <React.Fragment>
                <div className="section">
                    <Spaced className="cover__container cover--city section">
                        <div className="cover__img" style={imageStyle} />
                        <div className="cover__content">
                            <div className="cover__name">
                                <h1>{data.Name}</h1>
                                <h4 className="cover__meta">
                                    {
                                        this.state.showsCurrent.total != undefined &&
                                        this.state.showsPast.total != undefined &&
                                        <a href="#" name="shows" onClick={this.handleMetaClick}>{this.state.showsCurrent.total + this.state.showsPast.total} show{(this.state.showsCurrent.total + this.state.showsPast.total) != 1 ? 's' : ''}</a>
                                    }
                                    {
                                        this.state.galleries.all != undefined &&
                                        <React.Fragment>
                                            <span> - </span>
                                            <a href="#" name="galleries" onClick={this.handleMetaClick}>{this.state.galleries.all.length} galler{this.state.galleries.all.length != 1 ? 'ies' : 'y'}</a>
                                        </React.Fragment>
                                    }
                                    {
                                        this.state.artists.total != undefined &&
                                        <React.Fragment>
                                            <span> - </span>
                                            <a href="#" name="artists" onClick={this.handleMetaClick}>{this.state.artists.total} artist{this.state.artists.total != 1 ? 's' : ''}</a>
                                        </React.Fragment>
                                    }
                                </h4>
                                <br />
                                <FollowButton data={data} onChange={this.handleFollowChange} />
                            </div>
                        </div>
                    </Spaced>
                </div>
                <Tab tabExtras={tabExtras} tabs={this.props.tabs} onClick={this.props.onTabClick}>
                    {
                        this.props.tab == 'galleries' &&
                        !Artcloud.auth.isauthed &&
                        <Spaced className="section banner--add-gallery">
                            <span className="banner__text">Add your gallery to Artcloud's comprehensive gallery guide</span>
                            <span className="banner__btn">
                                <LinkButton config={{ color: 'dark', size: 'medium', style: 'fill' }} onClick={this.handleGalleryAddClick}>Add My Gallery</LinkButton>
                            </span>
                        </Spaced>
                    }
                </Tab>
                <div className="section spacer--top">
                    {
                        !this.props.data &&
                        <LoadingIndicator />
                    }
                    {
                        this.props.tab == 'overview' &&
                        this.props.data &&
                        <React.Fragment>
                            {
                                this.props.data.Overview &&
                                this.props.data.Overview.length > 0 &&
                                <Spaced className="spacer--bottom">
                                    <p className="text--details">
                                        <span className="all">{this.props.data.Overview}</span>
                                    </p>
                                </Spaced>
                            }
                            {
                                !this.state.showsCurrent.loading &&
                                this.state.showsCurrent.data &&
                                <Spaced className="spacer--bottom">
                                    <ShowsSlider
                                        config={this.showsSliderConfig}
                                        data={this.state.showsCurrent.data}
                                        id="shows"
                                        slideProps={{ height: 250, cols: 2 }}
                                        titleContent={(
                                            <Title className="section__title--medium">
                                                <h2>Shows</h2>
                                                <Arrows display="See All" name="shows" renderAsLink={true} onClick={this.props.onTabClick} />
                                            </Title>
                                        )} />
                                </Spaced>
                            }
                            {
                                this.state.showsCurrent.loading &&
                                !this.state.galleries.loading &&
                                <LoadingIndicator />
                            }
                        
                            {
                                !this.state.galleries.loading &&
                                this.state.galleries.featured &&
                                <GalleriesSlider
                                    data={this.state.galleries.featured}
                                    id="galleries"
                                    titleContent={(
                                        <Title className="section__title--medium">
                                            <h2>Featured Galleries</h2>
                                            <Arrows display="See All" name="galleries" renderAsLink={true} onClick={this.props.onTabClick} />
                                        </Title>
                                    )}
                                />
                            }
                            {
                                this.state.galleries.loading &&
                                <LoadingIndicator />
                            }
                        </React.Fragment>
                    }
                    {
                        this.props.tab == 'shows' && 
                        <div>
                            {
                                hasCurrentShows &&
                                <React.Fragment>
                                    <Spaced>
                                        <TitleSpaced>
                                            <h3>Current and Upcoming Shows</h3>
                                        </TitleSpaced>
                                    </Spaced>
                                    <Spaced className="show__grid--cont">
                                        {this.state.showsCurrent.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                    </Spaced>
                                    <br />
                                </React.Fragment>
                            }
                            {
                                this.state.showsCurrent.loading &&
                                !this.state.showsPast.loading &&
                                <LoadingIndicator />
                            }
                            {
                                this.state.showsPast.data &&
                                this.state.showsPast.data.length > 0 &&
                                <React.Fragment>
                                    <Spaced>
                                        <TitleSpaced>
                                            <h3>Past Shows</h3>
                                        </TitleSpaced>
                                    </Spaced>
                                    <Spaced className="show__grid--cont container--waypoint">
                                        
                                        {this.state.showsPast.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                        <div className="loading--waypoint">
                                            <Waypoint onEnter={this.handleShowsWaypointEnter} />
                                        </div>
                                    </Spaced>
                                </React.Fragment>
                            }
                            {
                                this.state.showsPast.loading &&
                                <LoadingIndicator />
                            }
                        </div>
                    }
                    {
                        this.props.data &&
                        <Galleries
                            city={data}
                            data={this.state.galleries}
                            tab={this.props.tab} />
                    }
                    {
                        this.props.tab == 'artists' &&
                        <div>
                            {
                                this.state.artists.data &&
                                <React.Fragment>
                                    {
                                        this.state.artists.data.length == 0 &&
                                        <NoResults display="No Artists" />
                                    }
                                    {
                                        this.state.artists.data.length > 0 &&
                                        <Spaced className="artist__grid--cont container--waypoint">
                                            {this.state.artists.data.map((d) => <ArtistCell key={d.ArtistId} d={d} fixedHeight={true} onFollowChange={this.handleArtistFollowChange} />)}
                                            <div className="loading--waypoint">
                                                <Waypoint onEnter={this.handleArtistsWaypointEnter} />
                                            </div>
                                        </Spaced>
                                    }
                                </React.Fragment>
                            }
                            {
                                this.state.artists.loading &&
                                <LoadingIndicator />
                            }
                        </div>
                    }
                    {
                        this.props.tab == 'museums' &&
                        data.Museums &&
                        data.Museums.length > 0 &&
                        <div className="container container--spaced section" dangerouslySetInnerHTML={{ __html: data.Museums }} />
                    }
                </div>
                {
                    this.state.galleryAddModal &&
                    <GalleryAddModal onClose={this.handleGalleryAddClose} />
                }
            </React.Fragment>
        )
    }
}

class Galleries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleMapMarkerClick = this.handleMapMarkerClick.bind(this);
        this.handleMapMarkerClose = this.handleMapMarkerClose.bind(this);
        this.handleSideBarClick = this.handleSideBarClick.bind(this);
    }

    handleMapMarkerClick(marker) {
        if (!marker.props) {
            return;
        }
        const galleryId = marker.props.id;
        let gallery, temp;
        for (let i = 0; i < this.props.data.all.length; i++) {
            temp = this.props.data.all[i];
            if (temp.GalleryId != galleryId) {
                continue;
            }
            gallery = temp;
            break;
        }
        if (!gallery) {
            return;
        }
        this.setState({
            activeGallery: gallery
        });

        let element;
        if (gallery.IsFeatured) {
            element = document.getElementById(`featured-${gallery.GalleryId}`);
        } else {
            element = document.getElementById(`all-${gallery.GalleryId}`);
        }
        const container = document.getElementById('galleries__map-sidebar');
        if (!container || !element) {
            return;
        }
        container.scrollTop = element.offsetTop - (container.offsetHeight / 2) + (element.offsetHeight / 2);
    }

    handleMapMarkerClose() {
        this.setState({
            activeGallery: undefined
        });
    }

    handleSideBarClick(d) {
        // Clear the existing active gallery before setting the new one (ensure UI updates properly)
        const component = this;
        component.setState({
            activeGallery: undefined
        }, function () {
            const activeGallery = { ...d };
            activeGallery.spiderfy = true;
            component.setState({
                activeGallery: activeGallery
            });
        });
    }

    render() {
        const component = this;
        const activeId = component.state.activeGallery ? component.state.activeGallery.GalleryId : undefined;
        const props = component.props;
        const Cell = props.data.mapVisible ? GallerySideBarCell : GalleryCell;
        let content = (
            <React.Fragment>
                {
                    props.data.loading &&
                    <LoadingIndicator />
                }
                {
                    props.data.featured &&
                    props.data.featured.length > 0 &&
                    <React.Fragment>
                        <Title className="section__title--medium">
                            <h4>Featured Galleries</h4>
                        </Title>
                        <div className="gallery__grid__cont">
                            {props.data.featured.map((d) => <Cell key={d.GalleryId} active={d.GalleryId == activeId} d={d} featured={true} onClick={component.handleSideBarClick} />)}
                        </div>
                    </React.Fragment>
                }
                {
                    !props.data.loading &&
                    <React.Fragment>
                        <Title className="section__title--medium">
                            <h4 className="m-b-sm">All Galleries</h4>
                        </Title>
                        {
                            props.data.all.length == 0 &&
                            <NoResults display="No Results" />
                        }
                        {
                            props.data.all.length > 0 &&
                            <div className="letters--grid">
                                {props.data.all.map((d) => <Cell key={d.GalleryId} active={d.GalleryId == activeId} d={d} onClick={component.handleSideBarClick} />)}
                            </div>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        );

        let className;
        if (props.data.mapVisible) {
            className = 'galleries__map map--view__container container--split split';
            content = (
                <div className="map--view__sidebar split--fixed__view" id="galleries__map-sidebar">
                    {content}
                </div>
            );
        } else {
            className = 'galleries__thumb';
        }
        let style;
        if (props.tab != 'galleries') {
            if (props.data.loading) {
                style = { opacity: 0 };
            } else {
                style = { display: 'none' };
            }
        }
        return (
            <div className="section">
                <Spaced className={className} style={style}>
                    {content}
                    {
                        props.data.mapVisible &&
                        <div className="map--view__map-container split--toggle__view">
                            <div className="split__content">
                                <Map
                                    activeGallery={component.state.activeGallery}
                                    data={props.data.all}
                                    latitude={props.city.Latitude}
                                    longitude={props.city.Longitude}
                                    onMarkerClick={component.handleMapMarkerClick}
                                    onMarkerClose={component.handleMapMarkerClose} />
                            </div>
                        </div>
                    }
                </Spaced>
            </div>
        );
    }
}

class GalleryAddModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(name, value) {
        this.setState({
            [name]: value
        });
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(event) {
        if (event) {
            event.preventDefault();
        }
    }

    render() {
        return (
            <Popup className="text--center popup--add-gallery" type='container' onClose={this.handleClose}>
                <img alt="" className="form--signup__logo" src="../assets/img/logos/header-mark.svg" />
                <h5 className="form--signup__header">Add your gallery to <br />Artcloud's comprehensive gallery guide</h5>
                <HubspotForm formId="04e7a9e3-e95a-4ec1-8e31-68cc95c1a474" portalId="4285812" onFormSubmitted={this.handleClose} />
            </Popup>
        )
    }
}

function GalleryCell(props) {
    const data = props.d || {};
    const link = `/gallery/${data.Slug}`;
    let content = <a href={link}>{data.Company}</a>;
    if (props.featured) {
        content = (
            <div className="gallery__info">
                {content}
            </div>
        );
    }
    return (
        <div className="grid grid--4">
            <div className="gallery__grid">
                {
                    props.featured &&
                    data.Image &&
                    <LinkedImage
                        alt={data.Company}
                        imageClass={"gallery__img"}
                        image={data.Image}
                        link={link}
                        type={"fill"}
                        cols={3}
                    />
                }
                {content}
            </div>
        </div>
    );
}

class GallerySideBarCell extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.props.onClick(this.props.d);
    }

    render() {
        let className = 'grid grid--3';
        if (this.props.active) {
            className += ' active';
        }
        const data = this.props.d || {};
        const id = (this.props.featured ? 'featured-' : 'all-') + data.GalleryId;
        return (
            <div className={className} id={id} onClick={this.handleClick}>
                <div className="gallery__grid">
                    {

                        this.props.featured &&
                        <React.Fragment>
                            {
                                data.Image &&
                                <LinkedImage
                                    alt={data.Company}
                                    imageClass={"gallery__img--cover"}
                                    image={data.Image}
                                    type={"fill"}
                                    height={100}
                                    width={100}
                                />
                            }
                            <div className="gallery__info">
                                <h3 className="gallery__info__title">{data.Company}</h3>
                                {
                                    data.Artists != undefined &&
                                    <p className="gallery__info__meta">{data.Artists} artist{data.Artists != 1 ? 's' : ''}</p>
                                }
                                {
                                    data.Artworks != undefined &&
                                    <p className="gallery__info__meta">{data.Artworks} artwork{data.Artworks != 1 ? 's' : ''}</p>
                                }
                                <LinkButton config={{ color: 'dark', size: 'tiny' }} link={`/gallery/${data.Slug}`}>View Profile</LinkButton>
                            </div>
                        </React.Fragment>
                    }
                    {
                        !this.props.featured &&
                        data.Company
                    }
                </div>
            </div >
        );
    }
}

class Map extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            center: { lat: props.latitude, lng: props.longitude }
        };

        this.handleInfoWindowLoad = this.handleInfoWindowLoad.bind(this);
        this.handleInfoWindowReady = this.handleInfoWindowReady.bind(this);
        this.handleInfoWindowUnmount = this.handleInfoWindowUnmount.bind(this);
        this.handleMapLoad = this.handleMapLoad.bind(this);
        this.handleMarkerManagerRef = this.handleMarkerManagerRef.bind(this);
        this.handleSpiderfy = this.handleSpiderfy.bind(this);
    }

    handleInfoWindowLoad(infoWindow) {
        this.setState({
            infoWindow: infoWindow
        });
    }

    handleInfoWindowReady() {
        if (!this.state.mapInstance || !this.state.infoWindow || !this.state.infoWindow.content) {
            return;
        }

        const projection = this.state.mapInstance.getProjection();
        const center = projection.fromLatLngToPoint(this.state.mapInstance.center);
        const point = projection.fromLatLngToPoint(this.state.infoWindow.position);
        const quandrant = `${point.y > center.y ? 'b' : 't'}${point.x < center.x ? 'l' : 'r'}`;
        const bounds = this.state.mapInstance.getBounds();
        const scale = Math.pow(2, this.state.mapInstance.getZoom());

        let x, y;
        switch (quandrant) {
            case 'bl': {
                const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
                const infoWindowBottom = ((point.y - bottomLeft.y) * scale) + 20.0;
                const infoWindowLeft = ((point.x - bottomLeft.x) * scale) - (this.state.infoWindow.content.offsetParent.offsetWidth / 2.0) - 12;

                if (infoWindowBottom > 0) {
                    y = infoWindowBottom;
                }
                if (infoWindowLeft < 0) {
                    x = infoWindowLeft;
                }
                break;
            }
            case 'br': {
                // Account for zoom controls and copyright
                const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
                const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
                const infoWindowBottom = ((point.y - bottomLeft.y) * scale) + 30.0;
                const infoWindowRight = ((point.x - topRight.x) * scale) + (this.state.infoWindow.content.offsetParent.offsetWidth / 2.0) + 60;
                if (infoWindowBottom > 0) {
                    y = infoWindowBottom;
                }
                if (infoWindowRight > 0) {
                    x = infoWindowRight;
                }
                break;
            }
            case 'tl': {
                const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
                const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
                const infoWindowLeft = ((point.x - bottomLeft.x) * scale) - (this.state.infoWindow.content.offsetParent.offsetWidth / 2.0) - 12;
                const infoWindowTop = ((point.y - topRight.y) * scale) - this.state.infoWindow.content.offsetParent.offsetHeight - 35.0;

                if (infoWindowTop < 0) {
                    y = infoWindowTop;
                }
                if (infoWindowLeft < 0) {
                    x = infoWindowLeft;
                }
                break;
            }
            case 'tr': {
                const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
                const infoWindowRight = ((point.x - topRight.x) * scale) + (this.state.infoWindow.content.offsetParent.offsetWidth / 2.0) + 12;
                const infoWindowTop = ((point.y - topRight.y) * scale) - this.state.infoWindow.content.offsetParent.offsetHeight - 35.0;

                if (infoWindowTop < 0) {
                    y = infoWindowTop;
                }
                if (infoWindowRight > 0) {
                    x = infoWindowRight;
                }
                break;
            }
        }
        if (!x && !y) {
            return;
        }
        const component = this;
        component.state.mapInstance.panBy(x || 0, y || 0);
        setTimeout(function () {
            component.setState({
                center: component.state.mapInstance.getCenter()
            });
        }, 500);
    }

    handleInfoWindowUnmount() {
        this.setState({
            infoWindow: undefined
        });
    }

    handleMapLoad(mapInstance) {
        this.setState({
            mapInstance: mapInstance
        });
    }

    handleMarkerManagerRef(ref) {
        this.markerManagerRef = ref;
    }

    handleSpiderfy(marker) {
        if (!marker || !this.markerManagerRef || !this.markerManagerRef.manager) {
            return;
        }
        this.markerManagerRef.manager.spiderListener(marker);
    }

    render() {
        const component = this;
        const _data = component.props.data || [];
        const markers = _data.map(function (d, i) {
            return {
                id: d.GalleryId,
                label: d.mapLabel,
                position: {
                    lat: d.Latitude,
                    lng: d.Longitude
                },
                slug: d.Slug,
                title: d.Company,
                zIndex: (i + 1)
            };
        });

        const options = {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#fc6e6e"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "hue": "#008aff"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#bee0ee"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        };
        return (
            <LoadScriptNext
                googleMapsApiKey="AIzaSyCrgYYx5ISnIYiSDriVBse4tWZEV5Xc48A"
                loadingElement={<div style={{ height: `100%` }} />}>
                <GoogleMap
                    center={component.state.center}
                    clickableIcons={false}
                    mapContainerStyle={{ height: '100%' }}
                    options={options}
                    zoom={13}
                    onClick={component.props.onMarkerClose}
                    onLoad={component.handleMapLoad}>
                    {
                        component.state.mapInstance != undefined &&
                        <MapMarkerManager ref={component.handleMarkerManagerRef} map={component.state.mapInstance} onMarkerClick={component.props.onMarkerClick}>
                            {
                                markers.map((marker) =>
                                    <MapMarker
                                        key={marker.id}
                                        activeGallery={component.props.activeGallery}
                                        {...marker}
                                        onInfoWindowCloseClick={component.props.onMarkerClose}
                                        onInfoWindowDomReady={component.handleInfoWindowReady}
                                        onInfoWindowLoad={component.handleInfoWindowLoad}
                                        onInfoWindowUnmount={component.handleInfoWindowUnmount}
                                        onMarkerClick={component.props.onMarkerClick}
                                        onSpiderfy={component.handleSpiderfy}
                                        onUnmount={component.handleInfoWindowUnmount}>
                                    </MapMarker>
                                )
                            }
                        </MapMarkerManager>
                    }
                </GoogleMap>
            </LoadScriptNext>
        );
    }
}

function MapInfoWindow(props) {
    const data = props.d || {};
    const options = {
        disableAutoPan: true,
        pixelOffset: { height: -12, width: 0 }
    };
    return (
        <InfoWindow
            id="infoWindow"
            options={options}
            position={props.position}
            onCloseClick={props.onCloseClick}
            onDomReady={props.onDomReady}
            onLoad={props.onLoad}
            onUnmount={props.onUnmount}>
            <div className="marker--popup">
                {
                    data.ImageUrl &&
                    data.ImageUrl.length &&
                    <div className="marker--popup__image" style={{ backgroundImage: `url('${data.ImageUrl}')` }} />
                }
                <div className="marker--popup__title"><h3>{data.Company}</h3></div>
                {
                    data.Artists > 0 &&
                    <div className="marker--popup__artists">{data.Artists} artist{data.Artists != 1 ? 's' : ''}</div>
                }
                {
                    data.Artworks > 0 &&
                    <div className="marker--popup__artworks">{data.Artworks} artwork{data.Artworks != 1 ? 's' : ''}</div>
                }
                <div className="marker--popup__link">
                    <LinkButton config={{ color: 'dark', size: 'tiny' }} link={`/gallery/${data.Slug}`} target="_blank">View More</LinkButton>
                </div>
            </div>
        </InfoWindow>
    );
}

const mapMarkerIcon = {
    fillColor: '#333333',
    fillOpacity: 1,
    path: 'M30,13a7,7,0,0,1-7,7H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0H23a7,7,0,0,1,7,7Z',
    scale: 1,
    strokeColor: '#555555',
    anchor: { x: 15, y: 10 },
    labelOrigin: { x: 15, y: 10 },
    origin: { x: 5, y: 0 }
};
class MapMarker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleLoad = this.handleLoad.bind(this);
        this.handlePositionChanged = this.handlePositionChanged.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeGallery && !this.props.activeGallery) {
            this.setState({
                position: undefined
            });
        }
        if ((!prevProps.activeGallery || prevProps.activeGallery.GalleryId != prevProps.id) && this.props.activeGallery && this.props.activeGallery.spiderfy && this.props.activeGallery.GalleryId == this.props.id) {
            const component = this;
            setTimeout(function () {
                component.props.onSpiderfy(component.markerInstance);
            }, 100);
            // google.maps.event.trigger(this.markerInstance, 'click');
            this.props.activeGallery.spiderfy = undefined;
        }
    }

    handleLoad(markerInstance) {
        this.markerInstance = markerInstance;
    }

    handlePositionChanged() {
        if (!this.markerInstance) {
            return;
        }
        this.setState({
            position: this.markerInstance.position
        });
    }

    render() {
        let position = this.props.position;
        if (this.state.position) {
            position = this.state.position;
        }
        return (
            <Marker
                icon={mapMarkerIcon}
                {...this.props}
                position={position}
                onLoad={this.handleLoad}
                onPositionChanged={this.handlePositionChanged}>
                {
                    this.props.activeGallery &&
                    this.props.activeGallery.GalleryId == this.props.id &&
                    <MapInfoWindow
                        d={this.props.activeGallery}
                        position={position}
                        onCloseClick={this.props.onInfoWindowCloseClick}
                        onDomReady={this.props.onInfoWindowDomReady}
                        onLoad={this.props.onInfoWindowLoad}
                        onUnmount={this.props.onInfoWindowUnmount} />
                }
            </Marker>
        )
    }
}

class MapMarkerManager extends React.Component {
    constructor(props) {
        super(props);

        this.manager = new OverlappingMarkerSpiderfier(
            props.map,
            {
                keepSpiderfied: true,
                nearbyDistance: 28
            }
        );

        this.handleMarkerNodeMounted = this.handleMarkerNodeMounted.bind(this);
    }

    handleMarkerNodeMounted(marker) {
        const component = this;
        setTimeout(function () {
            if (!marker || !marker.markerInstance || !marker.props) {
                return;
            }
            component.manager.addMarker(marker.markerInstance);
            marker.markerInstance.addListener('mouseup', function () {
                if (component.props.onMarkerClick) {
                    component.props.onMarkerClick(marker);
                }
            })
        }, 200);
    }

    render() {
        const component = this;
        return React.Children.map(component.props.children, child =>
            React.cloneElement(child, { ref: component.handleMarkerNodeMounted })
        );
    }
}

function ShowCell(props) {
    return (
        <div className="grid grid--6 spacer--bottom">
            <ShowVertical
                className="show__grid"
                cols={2}
                slider={false}
                {...props} />
        </div>
    )
}

const City = forResource(_City, Artcloud.url.vendor.marketplace.cities.getid);
export default City;